var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'proveedores')?_c('div',[_c('nav-component'),_c('loader'),_c('rendimiento-general'),_c('rendimiento-por-proveedor')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }